import { HTTP, HTTP_RETROFIT, authHeader } from './http-service';

class BrandmisuseService {
  get(payload) {
    return HTTP.get(`/DisputesBrandMisuse/${payload.disputeId}`, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  create(payload) {
    return HTTP.post(`/DisputesBrandMisuse`, payload, { headers: authHeader() }).then((response) => {
      return response.data;
    });
  }

  update(payload) {
    return HTTP.put(`/DisputesBrandMisuse`, payload, { headers: authHeader() }).then((response) => {
      return response.data;
    });
  }

  delete(payload) {
    return HTTP.delete(`/DisputesBrandMisuse/${payload.disputeId}`, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  getByProjectReference(projectReference) {
    return HTTP_RETROFIT.get(`/BackOfficeDispute/projectReference/${projectReference}`, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  getByLodgementCertificateNumber(lodgementCertificateNumber) {
    return HTTP_RETROFIT.get(`/BackOfficeDispute/lodgement/${lodgementCertificateNumber}`, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  getByUMR(umr) {
    return HTTP_RETROFIT.get(`/BackOfficeDispute/measure/${umr}`, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  deleteBrandmisuseFollowUpDate(payload) {
    return HTTP.delete(`/DisputesBrandMisuse/${payload.disputeId}/brandMisuseFollowUpDate`, {
      headers: authHeader(),
    }).then((response) => {
      return response;
    });
  }

  updateTradingStandards(payload) {
    return HTTP.put(`/DisputesBrandMisuse/${payload.disputeId}/tradingstandards`, payload.tradingStandards, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }
}

export default new BrandmisuseService();
